import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import focusDropdownSearch from 'scaleflow/utils/focus-dropdown-search';
import nameSort from 'scaleflow/utils/nameSort';

export default class DropdownsInitiativesComponent extends Component {
  @service store;
  @service betaToggle;

  @tracked textFilter = null;

  allowedStatus = [
    'ACTIVE',
    'READY',
    'DRAFT',
    'READY FOR PLANNING',
    'DISCOVERY',
  ];

  tippyInstance = null;

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  get trigger() {
    return this.args?.trigger ?? '';
  }

  get placement() {
    return this.args.placement ?? 'top';
  }

  get interactive() {
    return this.args.interactive ?? false;
  }

  get initiatives() {
    const initiatives = this.store.peekAll('initiative');
    return !this.textFilter
      ? initiatives
      : initiatives.filter(
          (item) =>
            item.title.toLowerCase().indexOf(this.textFilter.toLowerCase()) >=
              0 ||
            (item?.abbreviation ?? '')
              .toLowerCase()
              .indexOf(this.textFilter.toLowerCase()) >= 0,
        );
  }

  get initiativesList() {
    const initiatives = this.initiatives;
    let filtered = [];
    if (this.args.allowAllStatuses) filtered = [...initiatives];
    else
      filtered = initiatives.filter((item) =>
        this.allowedStatus.includes(item?.status?.toUpperCase?.()),
      );
    return filtered.sort((a, b) => nameSort(a.title, b.title));
  }

  @action
  handleInitiativeClick(item) {
    this.args?.onSelect?.(item);
    this.tippyInstance.hide();
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  onShown(instance) {
    focusDropdownSearch(instance);
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  @action
  handleClearSelection() {
    this.args?.handleClearSelection();
    this.tippyInstance.hide();
  }
}
